import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("span", {
    ref: "tip",
    class: "info-tip",
    tabindex: "0",
    "aria-label": _ctx.text,
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.place())),
    onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.place()))
  }, [
    _createVNode(_component_svg_icon, { icon: "ibubble2" }),
    _createElementVNode("span", {
      ref: "pop",
      class: _normalizeClass(["info-tip-pop", _ctx.above ? 'above' : '']),
      style: _normalizeStyle(_ctx.popStyle),
      role: "tooltip"
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.text), 1)
      ])
    ], 6)
  ], 40, _hoisted_1))
}